import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_SIZE_UPLOADED_FILE } from '../../config';

//MAX_SIZE_UPLOADED_FILE
const DocumentUpload = ({ setFile, setCheckUpdateValue,document,accept='.pdf,.doc,.docx'}) => {
    DocumentUpload.propTypes = {
        setFile: PropTypes.func,
        setCheckUpdateValue: PropTypes.func,
        document:PropTypes.any,
        accept:PropTypes.any,
    };

    const [filename, setFilename] = useState('Choisir un fichier ('+accept+', Taille max. : 5 MB)');
    const [error, setError] = useState(false);
    const fileInputRef = useRef(null);
    const { i18n } = useTranslation();
    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        if(e.target.files[0]?.size < MAX_SIZE_UPLOADED_FILE) {
            console.log(e.target.files[0]);
            setFile(e.target.files[0]);
            setFilename(e.target.files[0]?.name);
            fileInputRef.current.value = null;
            if (typeof setCheckUpdateValue === 'function') {
                setCheckUpdateValue(false);
            }
            setError(false);
        }
        else {
            setFilename('Veuillez respecter la taille maximale du fichier');
            setError(true);
        }
    };

    useEffect(() => {
        if (document == '')
            setFilename('Choisir un fichier ('+accept+', Taille max. : 5 MB)');
    }, [document]);

    return (
        <Fragment>
            <form style={{ alignSelf: 'stretch' }} >
                <input
                    type='file'
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    className='custom-file-input'
                    accept={accept}
                    //key={key}
                    readOnly
                />
                <div
                    className='UploadContainer'
                    onClick={handleImageClick}
                    style={{ cursor: 'pointer' }}
                >

                    <img
                        src='/img_card/upload_icon3.jpg'
                        style={{ width: '52px', height: '70px', cursor: 'pointer' }}
                    />
                    <label
                        className='custom-file-label'
                        style={{color: error ? 'red' : 'black'}}
                    >
                        {i18n.t(filename)}
                    </label>
                </div>
            </form>
        </Fragment>
    );
};

export default DocumentUpload;